import TagManagement from './tag-management'
export default TagManagement
